import { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { changeUserInfo, checkSession } from "modules/login/login";
import { setToken } from "lib/api/client";

class Core extends Component {
  logout = async () => {
    // redux에 로그인정보 삭제
    await this.props.changeUserInfo(null);

    // localStorage에 로그인정보 삭제
    localStorage.removeItem("ctcrAuth");
  };

  initialize = async () => {
    // 로그인 설정 불러오기
    const authorization = localStorage.getItem("ctcrAuth");
    if (!authorization) return;

    const parsedAuth = JSON.parse(authorization);
    setToken(`${parsedAuth.token}`);

    try {
      const response = await this.props.checkSession();

      if (!response.data.data) {
        this.logout();
        return false;
      }

      // 자바 세션 유지시
      await this.props.changeUserInfo(parsedAuth);
    } catch (e) {
      localStorage.removeItem("ctcrAuth");
    }
  };

  setLoad = () => {
    // 첫 화면 load시 browser 정보에 따라 locale 변경
    let browserLang;
    switch (navigator.language) {
      case "ko-KR":
        browserLang = "kr";
        break;
      case "en-US":
        browserLang = "en";
        break;
      case "zh-CN":
        browserLang = "cn";
        break;
      case "ja":
        browserLang = "jp";
        break;
      default:
        browserLang = "kr";
    }

    // 언어 설정
    const locale = this.props.location.pathname.split("/")[1];
    localStorage.setItem("ctcrLocale", locale === "" ? browserLang : locale);

    // 로그인 설정 불러오기
    this.initialize();
  };

  componentDidMount() {
    this.setLoad();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.setLoad();
    }
  }

  render() {
    return null;
  }
}

export default connect(undefined, { changeUserInfo, checkSession })(
  withRouter(Core)
);
